import React from 'react'

function Home() {
  return (
    <section className="hero" id="home">
      <div className="hero-container">
        <div className="hero-content">
          <div className="hero-badge">Available for work</div>
          <h1 className="hero-title">
            Hi, I'm <span className="highlight">Freddy</span>
            <br />
            Full-Stack Developer
          </h1>
          <p className="hero-description">
            Melbourne based system engineer specializing in building exceptional
            digital experiences. I create custom websites and mobile apps that
            help businesses thrive online.
            <br />
            <a href="#contact">Let's work together!</a>
          </p>
          <div className="hero-buttons">
            <a href="#projects" className="hero-btn hero-btn-primary">
              View My Work
            </a>
            <a href="#contact" className="hero-btn hero-btn-secondary">
              Get In Touch
            </a>
          </div>
        </div>
        <div className="hero-visual">
          <div className="hero-decoration"></div>
          <div className="hero-code-window">
            <div className="code-window-header">
              <span className="code-dot red"></span>
              <span className="code-dot yellow"></span>
              <span className="code-dot green"></span>
            </div>
            <div className="code-window-content">
              <div className="code-line line-1">
                <span className="line-number">1</span>
                <span className="line-content">
                  <span className="keyword">const</span>{' '}
                  <span className="variable">developer</span> = {'{'}
                </span>
              </div>
              <div className="code-line line-2">
                <span className="line-number">2</span>
                <span className="line-content">
                  {'  '}
                  <span className="property">name</span>:{' '}
                  <span className="string">'Freddy'</span>,
                </span>
              </div>
              <div className="code-line line-2">
                <span className="line-number">3</span>
                <span className="line-content">
                  {'  '}
                  <span className="property">location</span>:{' '}
                  <span className="string">'Melbourne'</span>,
                </span>
              </div>
              <div className="code-line line-2">
                <span className="line-number">4</span>
                <span className="line-content">
                  {'  '}
                  <span className="property">skills</span>: [
                </span>
              </div>
              <div className="code-line line-3">
                <span className="line-number">5</span>
                <span className="line-content">
                  {'    '}
                  <span className="string">'Docker'</span>,{' '}
                  <span className="string">'TypeScript'</span>,
                </span>
              </div>
              <div className="code-line line-3">
                <span className="line-number">6</span>
                <span className="line-content">
                  {'    '}
                  <span className="string">'.NET'</span>,{' '}
                  <span className="string">'SQL'</span>,{' '}
                  <span className="string">'React Native'</span>
                </span>
              </div>
              <div className="code-line line-2">
                <span className="line-number">7</span>
                <span className="line-content">{'  '}]</span>
              </div>
              <div className="code-line line-2">
                <span className="line-number">8</span>
                <span className="line-content">
                  {'  '}
                  <span className="function">create</span>
                  <span className="variable">Awesome</span>
                  <span className="keyword">()</span>;
                </span>
              </div>
              <div className="code-line line-1">
                <span className="line-number">9</span>
                <span className="line-content">{'}'}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default Home
